import { cloneElement, useLayoutEffect, useRef } from "react";

/**
 * Wraps a react-step-wizard step and makes it inert while it isn't the active one.
 * The wizard keeps every step mounted and only hides the inactive ones visually, so without this
 * their fields can still be focused with the keyboard (Tab, iOS keyboard arrows) and submitted.
 * The `inert` DOM property is set directly because React 18 doesn't know the attribute.
 *
 * @param {object} props - The props react-step-wizard injects (isActive, nextStep, goToStep...),
 *   forwarded untouched to the wrapped step, plus `children`: the step element.
 */
const WizardStep = ({ children, ...wizardProps }) => {
  const containerRef = useRef(null);
  const { isActive } = wizardProps;

  useLayoutEffect(() => {
    containerRef.current.inert = !isActive;
  }, [isActive]);

  return <div ref={containerRef}>{cloneElement(children, wizardProps)}</div>;
};

export default WizardStep;
